import { AxiosInstance, CustomParamsSerializer } from 'axios';
import qs from 'query-string';
import {
  HttpDeleteConfig,
  HttpGetConfig,
  HttpHeadConfig,
  HttpPostConfig,
  ResponseHeaders,
  RestClient,
} from 'types';
import { defaultToUndefined } from 'utils/lang';
import authHeaderRequestInterceptor from './authHeaderRequestInterceptor';

const paramsSerializer: CustomParamsSerializer = (params) =>
  qs.stringify(params);

export default class AxiosClient implements RestClient {
  private tokenRequestInterceptorId: number;

  constructor(private axios: AxiosInstance) {
    this.tokenRequestInterceptorId = axios.interceptors.request.use(
      ...authHeaderRequestInterceptor(),
    );
  }

  async get<R>(url: string, config: HttpGetConfig = {}): Promise<R> {
    const { disableAuthHeader, ...restConfig } = config;

    const { data } = await this.axios.get(url, {
      ...restConfig,
      disableAuthHeaderInterceptor: disableAuthHeader,
      paramsSerializer,
    });
    return data;
  }

  async post<R, D = unknown>(
    url: string,
    config: HttpPostConfig<D>,
  ): Promise<R> {
    const { data: payload, disableAuthHeader, ...restConfig } = config;
    const { data } = await this.axios.post(url, payload, {
      ...restConfig,
      disableAuthHeaderInterceptor: disableAuthHeader,
      paramsSerializer,
    });
    return data;
  }

  async delete<R>(url: string, config: HttpDeleteConfig = {}): Promise<R> {
    const { disableAuthHeader, ...restConfig } = config;

    const { data } = await this.axios.delete(url, {
      ...restConfig,
      disableAuthHeaderInterceptor: disableAuthHeader,
    });

    return data;
  }

  async head(
    url: string,
    config: HttpHeadConfig = {},
  ): Promise<ResponseHeaders> {
    const { disableAuthHeader, ...restConfig } = config;

    const result = await this.axios.head(url, {
      ...restConfig,
      disableAuthHeaderInterceptor: disableAuthHeader,
      paramsSerializer,
    });

    const headers = {
      contentLength: defaultToUndefined(
        result.headers['content-length'] as string,
      ),
    };

    return headers;
  }
}
